var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M17.593 2.166H8.407c-2.99 0-4.074 1.083-4.074 4.128v13.411c0 3.044 1.084 4.128 4.074 4.128h9.176c3 0 4.084-1.084 4.084-4.128V6.294c0-3.045-1.084-4.128-4.074-4.128ZM13 20.908a1.905 1.905 0 0 1-1.896-1.896c0-1.04.856-1.896 1.896-1.896s1.896.856 1.896 1.896-.856 1.896-1.896 1.896ZM15.167 6.77h-4.333a.818.818 0 0 1-.813-.812c0-.444.368-.813.813-.813h4.333c.444 0 .812.369.812.813a.818.818 0 0 1-.812.812Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M17.593 2.166H8.407c-2.99 0-4.074 1.083-4.074 4.128v13.411c0 3.044 1.084 4.128 4.074 4.128h9.176c3 0 4.084-1.084 4.084-4.128V6.294c0-3.045-1.084-4.128-4.074-4.128ZM13 20.908a1.905 1.905 0 0 1-1.896-1.896c0-1.04.856-1.896 1.896-1.896s1.896.856 1.896 1.896-.856 1.896-1.896 1.896ZM15.167 6.77h-4.333a.818.818 0 0 1-.813-.812c0-.444.368-.813.813-.813h4.333c.444 0 .812.369.812.813a.818.818 0 0 1-.812.812Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(128.66 9.094 6.746) scale(23.845 17.561)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.62cc91b4a32e40f6c415bf9cf9d0d968.svg";
export { ForwardRef as ReactComponent };